import * as React from 'react'
import { SVGProps } from 'react'

interface EffectProps extends SVGProps<SVGSVGElement> {
    viewBox: string
}

const Effect = ({ viewBox, ...props }: EffectProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height={100}
        width={'100%'}
        fill="#782bc5"
        preserveAspectRatio="none"
        viewBox={viewBox}
        {...props}
    >
        <path d="M0 100C20 0 50 0 100 100Z" />
    </svg>
)
export default Effect
